export default __webpack_public_path__ + "static/media/audio_16_vochito.37e37caa.mp3";